<footer
  class="w-100 bg-white d-flex flex-column justify-content-center align-items-center position-relative"
>
  <div
    class="bg-white d-flex justify-content-center align-items-center pt-4 pb-4"
  >
    <img
      class="logo_perval"
      src="assets/perval-icons/logo_perval_mini.svg"
      alt="perval"
    />
  </div>
  <div class="container-fluid linear-background text-white fs-5-text py-4">
    <div class="row justify-content-center align-items-center w-80 mx-auto">
      <div class="col-12 col-lg-5 text-center text-lg-end lh-sm">
        <!-- Bloc gauche -->
        <p class="fw-semibold">
          Vous souhaitez vendre ou acheter un bien immobilier,
        </p>
        <p>consultez nos sites partenaires :</p>
        <p>
          <a
            id="link_landing_footer_immo_notaires"
            href="https://www.immobilier.notaires.fr"
            target="_blank"
            rel="noopener noreferrer"
            class="a-style fs-5-text text-reset text-decoration-none landing-yellow-color fw-medium"
          >
            www.immobilier.notaires.fr
          </a>
        </p>
        <p class="mb-3">
          <a
            id="link_landing_footer_immo_interactif"
            href="https://www.immo-interactif.fr"
            target="_blank"
            rel="noopener noreferrer"
            class="a-style fs-5-text text-reset text-decoration-none landing-yellow-color fw-medium"
          >
            www.immo-interactif.fr
          </a>
        </p>
        <p class="fw-semibold">Vous recherchez un notaire,</p>
        <p>accédez à l’annuaire des notaires de France :</p>
        <p>
          <a
            id="link_landing_footer_directory"
            href="https://www.notaires.fr/fr/directory"
            target="_blank"
            rel="noopener noreferrer"
            class="a-style fs-5-text text-reset text-decoration-none landing-yellow-color fw-medium"
          >
            www.notaires.fr/fr/directory
          </a>
        </p>
      </div>

      <div
        class="col-12 col-lg-1 col-separator d-flex justify-content-center my-3 my-lg-0"
      >
        <hr class="footer-separator" />
      </div>

      <div class="col-12 col-lg-5 text-center text-lg-start">
        <!-- Bloc droit -->
        <p class="m-0">Perval est une ressource exclusive</p>
        <p class="mb-3">
          exploitée par la société
          <img
            class="inline-logo"
            src="assets/perval-icons/adnov_logo.svg"
            alt="Adenov"
          />
        </p>
        <p>
          Pour en savoir plus sur Perval,<br />
          <a
            target="_blank"
            href="https://www.adnov.fr/solutions/perval-base-de-donnees-marche-immobilier"
            id="link_landing_footer_database"
            class="a-style fs-5-text text-reset text-decoration-none landing-yellow-color fw-medium"
            >rendez-vous sur la page Adnov</a
          >
        </p>
      </div>
    </div>
  </div>

  <div
    class="bg-black w-100 d-flex justify-content-center landing-yellow-color"
  >
    <div
      class="w-80 d-flex justify-content-center align-items-center fs-7-text py-3"
    >
      <p class="m-0 text-white">® {{ year }} Perval.fr</p>
      <hr class="sm-hr" />
      <p class="m-0">
        <a
          id="link_landing_footer_mentions"
          [routerLink]="['mentions-legales']"
          class="a-style landing-yellow-color fw-medium text-decoration-none fs-7-text"
          >Mentions légales</a
        >
      </p>
      <hr class="sm-hr" />
      <p class="m-0">
        <a
          id="link_landing_footer_politique"
          (click)="onClickDPO()"
          target="_blank"
          class="a-style text-reset text-decoration-none landing-yellow-color fw-medium fs-7-text"
          >Données personnelles</a
        >
      </p>
    </div>
  </div>
  <div
    class="va-container d-none d-xxl-flex align-items-end justify-content-start position-absolute bottom-0 start-0 z-2 w-lg-25 overflow-hidden opacity-75"
  >
    <img class="v" src="assets/perval-icons/v.svg" alt="icone v" />
    <img class="a" src="assets/perval-icons/a.svg" alt="icone a" />
  </div>
</footer>
